export const feedback = {
  title: "Complaints and Suggestions",
  subtitle: "Family Complaints Collection and Management Protocol",
  protocol: {
    title: "Family Communication and Complaints Management Protocol",
    purpose: {
      title: "Purpose and Philosophy",
      points: [
        "Establish a clear, organized and effective channel for families to express their concerns, suggestions or complaints.",
        "Ensure that all communications are heard and treated with due attention and respect.",
        "Protect and support the teaching team, acting as a filter and facilitator in complaints management.",
        "Foster an environment of trust, respect and continuous improvement in the educational community."
      ]
    },
    scope: {
      title: "Application",
      description: "This protocol applies to all formal communications of complaints or concerns submitted by families of school students. It is also valid for collecting improvement proposals."
    }
  },
  contact: {
    title: "Single Reception Channel",
    email: {
      title: "Email Communication",
      description: "All complaints or concerns from families must be directed exclusively to the Director."
    },
    appointment: {
      title: "Prior Appointment with Management",
      description: "For cases that require a face-to-face conversation, they will always be attended with a prior appointment arranged through email.",
      note: "Families will be informed about this protocol and the single channel to ensure its correct use."
    }
  },
  process: {
    title: "Complaint Management Process",
    phases: [
      {
        title: "Phase 1: Reception and Initial Filter by Management",
        description: "The Director receives the complaint through the established channel and performs an initial analysis.",
        steps: [
          "Within a maximum period of 48 working hours, an acknowledgment of receipt will be sent to the family.",
          "The Director will perform a detailed reading and analysis of the complaint.",
          "Clarity, relevance, severity/urgency, competence and context will be evaluated.",
          "Filter objective: Protect the team from unfounded complaints and prioritize important ones."
        ]
      },
      {
        title: "Phase 2: Decision and Referral by Management",
        description: "Based on the initial analysis, the Director will decide the action to follow:",
        steps: [
          "Direct Resolution by Management: For minor complaints or simple misunderstandings.",
          "Referral to Team (Filtered and Managed): For complaints requiring staff intervention.",
          "Investigation or meeting with both parties: For serious or complex complaints.",
          "Non-Processable Complaint: If the complaint is unfounded or falls outside of competence."
        ]
      },
      {
        title: "Phase 3: Follow-up and Closure",
        description: "The Director supervises the evolution and communicates the resolution to the family.",
        steps: [
          "Internal coordination and follow-up of agreed actions.",
          "Communication to the family of the resolution or measures adopted.",
          "A satisfactory closure for all parties will be sought when possible."
        ]
      }
    ]
  },
  guarantees: {
    title: "Confidentiality and Respect",
    points: [
      "All information related to complaints will be treated with maximum confidentiality.",
      "A respectful environment will be promoted in all communications.",
      "An internal record will be maintained to identify patterns and areas for improvement.",
      "This protocol will be reviewed annually to ensure its effectiveness."
    ]
  }
};